/**
 * Kotak "Paid renewal" dalam popup Extend days (2026-10-14, arahan user — kes 601158883878).
 * Tick → RM + tarikh bayar → server merekod resit manual (orders, provider 'manual') SERENTAK
 * dengan tambah hari pada langganan yang sama (Gmail kekal). Paparan sahaja — semakan nilai:
 * utils/flowBayaranManual.js (client) + functions/flowResitManual.js (server).
 */
import { rmDariSen } from '../services/flowProdukService';

export default function FlowRenewBayarField({ aktif, onAktif, rm, onRm, tarikh, onTarikh, produkNama, produkSen, disabled }) {
    return (
        <div style={{ border: '1px solid var(--s-line)', borderRadius: 10, padding: '10px 12px' }}>
            <label className="s-chk">
                <input type="checkbox" checked={aktif} disabled={disabled} onChange={(e) => onAktif(e.target.checked)} />
                <span>
                    Paid renewal — the customer paid outside the system (bank transfer)
                    <br />
                    <span className="s-dim" style={{ fontSize: 12.5 }}>
                        A receipt is recorded in Orders and counted in the Dashboard. The days go on this same subscription, so the customer keeps the same Gmail and projects.
                    </span>
                </span>
            </label>
            {aktif && (
                <div className="s-kv" style={{ marginTop: 10 }}>
                    <div>
                        <p className="s-kv__lab">Amount paid (RM)</p>
                        <input className="s-inp" inputMode="decimal" placeholder={produkSen ? String(produkSen / 100) : 'e.g. 100'}
                            value={rm} disabled={disabled} onChange={(e) => onRm(e.target.value)} />
                        {produkNama && <p className="s-kv__hint">{produkNama}{produkSen ? ` · ${rmDariSen(produkSen)}` : ''}</p>}
                    </div>
                    <div>
                        <p className="s-kv__lab">Paid on</p>
                        <input className="s-inp" type="date" value={tarikh} disabled={disabled} onChange={(e) => onTarikh(e.target.value)} />
                        <p className="s-kv__hint">The Dashboard counts this sale in the month of this date.</p>
                    </div>
                </div>
            )}
        </div>
    );
}
